import React, { useState } from "react";
import { Box } from "@mui/material";
import { PageContainer } from "../../../components/container/PageContainer";
import { Breadcrumb } from "../../../layout/fullLayout/breadcrumb/Breadcrumb";
import { IBreadcrumbProps } from "../../../layout/fullLayout/breadcrumb/IBreadcrumbProps";
import { TabsList } from "../../../components/Tabs/TabsList";
import { TabPanel } from "../../../components/Tabs/TabPanel";
import { ReminderConfigList } from "./tabs/ReminderConfigList";
import { SentHistoryTable } from "./tabs/SentHistoryTable";
import { SendReminderManually } from "./tabs/SendReminderManually";



/**
 * ManagePaymentCampReminder
 *
 * Entry point for /payments/payment-reminder route.
 * 3 tabs:
 *   Tab 1: Reminders — config list (create/edit automation configs)
 *   Tab 2: Sent History — logs of sent reminders
 *   Tab 3: Send Reminder Manually — fetch booked leads + send on demand
 */
export const ManagePaymentCampReminder: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);

  const BCrumb: IBreadcrumbProps["items"] = [
    { to: "/dashboard", title: "Dashboard" },
    { title: "Payment Reminder" },
  ];

  return (
    <PageContainer
      title="Payment Reminder"
      description="Payment reminder campaigns"
    >
      <Breadcrumb title="Payment Reminder" items={BCrumb} />
      <Box >
        <TabsList
          varaint="fullWidth"
          selectedTab={activeTab}
          tabs={[
            { label: "Custom Reminder" },
            { label: "Sent History" },
            { label: "Reminder Configurations" },
          ]}
          onChange={(_, value) => setActiveTab(value)}
          sx={{ mb: 1 }}
        />


        <TabPanel value={activeTab} index={0}>
          <SentHistoryTable />
        </TabPanel>

        <TabPanel value={activeTab} index={1}>
          <SendReminderManually />
        </TabPanel>
        <TabPanel value={activeTab} index={2}>
          <ReminderConfigList />
        </TabPanel>
      </Box>
    </PageContainer>
  );
};
